/*
 * @Description: BI模板设置
 * @Date: 2024-01-08 15:49:22
 */
import { route } from './src/router';

const name = 'bi-tmpl';

export { name, route };
